import React from 'react'

/**
 * TypingBubble component displays an animated loading state for Virtual
 * Assistant interactions. Shows animated sparkles with "Just a sec..." text to
 * indicate the assistant is processing or responding.
 *
 * Used in both member and premember apps for Virtual Assistant loading states.
 *
 * @example
 *   ;```tsx
 *   <TypingBubble />
 *   ```
 */
export const TypingBubble: React.FC = () => {
  return (
    <div className="flex flex-wrap justify-start flex-1 h-full py-5 md:py-6 lg:py-5 px-5 md:px-6">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative m-1"
        aria-hidden="true"
      >
        <path
          d="M4.5 14.25C8.63658 12.7728 12.7732 10.0151 14.25 4.5C15.5309 10.0151 19.6674 12.7728 24 14.25C19.6674 15.5306 15.5309 19.6671 14.25 24C12.7732 19.6671 8.63658 15.5306 4.5 14.25Z"
          className="color-iconSidekick-default animate-star-large origin-bottom-right"
        />
        <path
          d="M0 5.25C2.22739 4.45461 4.45477 2.96968 5.25 0C5.9397 2.96968 8.16708 4.45461 10.5 5.25C8.16708 5.93953 5.9397 8.16692 5.25 10.5C4.45477 8.16692 2.22739 5.93953 0 5.25Z"
          className="color-iconSidekick-default animate-star-small origin-top-left"
        />
      </svg>
      Just a sec...
    </div>
  )
}
